import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavHeaderService {

  public _showNavigationHeaderSubject= new BehaviorSubject(false);
  showNavHeaderObs$ !: Observable<boolean>;

  constructor() { 
    this.showNavHeaderObs$ = this._showNavigationHeaderSubject.asObservable();
  }

  toggleHeaderVisibility(isShow:boolean){
    //console.log("Nav header visibility",isShow);
    this._showNavigationHeaderSubject.next(isShow)
  }
}
